// extracted by mini-css-extract-plugin
export default {"conteiner":"Loading_conteiner__7K5tB","gif":"Loading_gif__BhI4C"};